'use client';

import React from 'react';
import { CouponListScreen as BaseCouponListScreen } from '@kidslabs/module-flash-sale';

export const CouponListScreen: typeof BaseCouponListScreen = (
    props: Readonly<React.ComponentProps<typeof BaseCouponListScreen>>
) => <BaseCouponListScreen {...props} />;

export { CouponListScreenContent } from '@kidslabs/module-flash-sale';

export type CouponListScreenProps = React.ComponentProps<typeof BaseCouponListScreen>;
